export default class TransactionAppDelegate {
  constructor(item) {
    this.item = item;
  }
}
